import { render, staticRenderFns } from "./EditDBD.vue?vue&type=template&id=1974685d&"
import script from "./EditDBD.vue?vue&type=script&lang=js&"
export * from "./EditDBD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports